export default __webpack_public_path__ + "static/media/willy-dade.4cef5ad9.jpg";